import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { AppBar, Divider, IconButton, Stack, Toolbar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ChatLauncher } from '../../../../components/chat';
import AccountPopover from './components/accountPopover';
import NotificationsPopover from './components/notificationPopover';
import RegionSelector from './components/regionSelector';

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 60;

const RootStyle = styled(AppBar, {
	shouldForwardProp: (prop) => prop !== 'chatWidth' && prop !== 'isResizing',
})(({ theme, chatWidth, isResizing }) => ({
	boxShadow: 'none',
	backdropFilter: 'blur(6px)',
	WebkitBackdropFilter: 'blur(6px)',
	backgroundColor: alpha(theme.palette.background.default, 0.72),
	[theme.breakpoints.up('lg')]: {
		// Fixed to the right edge, so it has to step aside for the assistant
		// column as well as the navigation drawer.
		width: `calc(100% - ${DRAWER_WIDTH + 1}px - ${chatWidth}px)`,
		right: chatWidth,
		// Right when the panel opens or closes, wrong mid-drag: the bar would
		// trail the edge the user is holding.
		transition: isResizing
			? 'none'
			: theme.transitions.create(['width', 'right'], {
					easing: theme.transitions.easing.easeInOut,
					duration: theme.transitions.duration.standard,
			  }),
	},
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
	minHeight: APPBAR_MOBILE,
	[theme.breakpoints.up('lg')]: {
		minHeight: APPBAR_DESKTOP,
		padding: theme.spacing(0, 5),
	},
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
	onOpenSidebar: PropTypes.func,
	isChatAllowed: PropTypes.bool,
	isChatOpen: PropTypes.bool,
	isChatResizing: PropTypes.bool,
	chatWidth: PropTypes.number,
	onToggleChat: PropTypes.func,
};

export default function DashboardNavbar({
	onOpenSidebar,
	isChatAllowed,
	isChatOpen,
	isChatResizing,
	chatWidth = 0,
	onToggleChat,
}) {
	return (
		<RootStyle chatWidth={chatWidth} isResizing={isChatResizing}>
			<ToolbarStyle className="primary-bg shadow-md">
				<IconButton
					onClick={onOpenSidebar}
					className="!bg-white"
					sx={{
						mr: 1,
						color: 'text.primary',
						display: { lg: 'none' },
					}}>
					<MenuOutlinedIcon></MenuOutlinedIcon>
				</IconButton>

				<Stack
					width="100%"
					direction="row"
					alignItems="center"
					justifyContent="flex-end"
					spacing={{ xs: 0.5, sm: 2 }}>
					{/* <LanguagePopover /> */}
					{/* <AdminNotificationPopover /> */}
					{isChatAllowed ? (
						<>
							<ChatLauncher isOpen={isChatOpen} onToggle={onToggleChat} />
							<Divider
								orientation="vertical"
								flexItem
								sx={{ my: 1.25, borderColor: 'rgba(255,255,255,0.4)' }}
							/>
						</>
					) : null}
					<NotificationsPopover />
					<Divider
						orientation="vertical"
						flexItem
						sx={{ my: 1.25, borderColor: 'rgba(255,255,255,0.4)' }}
					/>
					<RegionSelector />
					<AccountPopover />
				</Stack>
			</ToolbarStyle>
		</RootStyle>
	);
}
